// Окно отчёта открывается синхронно, в жесте клика (иначе попап-блокер), а сам отчёт
// (reportHtml.ts, ~35 КБ) подгружается позже — поэтому эта функция вынесена отдельно.
// Открыть окно отчёта СИНХРОННО (в обработчике клика — иначе попап блокируется /
// about:blank). Возвращаем окно с заглушкой; финальный HTML пишем позже openReport(…, win).
export function openReportWindow(): Window | null {
  const w = window.open("", "_blank");
  if (w) {
    w.document.write('<!doctype html><html lang="ru"><head><meta charset="utf-8"><title>Отчёт ANYskin…</title></head>' +
      '<body style="font-family:system-ui,Arial,sans-serif;color:#64748b;padding:48px;font-size:14px">Готовим отчёт…</body></html>');
  }
  return w;
}
